/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Doors_OfflineInputs */



/**
* | output |
* | --- |
* | "The venue's connection is unreliable" |
*
* @param {Tournament_Wiz_Doors_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_doors_offline = /** @type {((inputs?: Tournament_Wiz_Doors_OfflineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Doors_OfflineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La connexion du lieu n'est pas fiable")
	if (locale === "es") return /** @type {LocalizedString} */ ("La conexión de la sede no es fiable")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A conexão do local não é confiável")
	if (locale === "it") return /** @type {LocalizedString} */ ("La connessione della sede non è affidabile")
	return /** @type {LocalizedString} */ ("The venue's connection is unreliable")
});